import { AccordionDetails, styled } from '@mui/material';

export const StyledAccordionDetails = styled(AccordionDetails)`
  padding: 0;
`;
